import { useCallback } from 'react'
import { defineMessages, useIntl } from 'react-intl'

import { CANCELLATION_POLICIES, CANCELLATION_POLICY_DAYS } from 'constants/cancellationPolicies'

const messages = defineMessages({
  nonRefundableTitle: {
    id: 'l-GTep8ScVK4dmBlicKL',
    defaultMessage: 'Non-refundable',
    description: 'Title of the non-refundable choice in the cancellation options picker on a flash hotel package card',
  },
  nonRefundableDescription: {
    id: 'McZnfbg7kjro59pfk1f1',
    defaultMessage: 'No refund if you cancel',
    description: 'Explanation under the non-refundable choice in the cancellation options picker on a flash hotel package card',
  },
  flexibleCancellationTitle: {
    id: 'twUrpREwmpnZAWZ01tfl',
    defaultMessage: 'Flexible cancellation',
    description: 'Title of the refund-to-credit choice in the cancellation options picker on a flash hotel package card',
  },
  fullyRefundableTitle: {
    id: '-kpWfe0eXciq2c4CO89J',
    defaultMessage: 'Fully refundable',
    description: 'Title of the cash-refund choice in the cancellation options picker on a flash hotel package card',
  },
  otherRefundableDescription: {
    id: 'd2PyB5AGO1t5VlNI3G-1',
    defaultMessage: 'Full refund if you cancel at least {days, plural, one {# day} other {# days}} before check-in',
    description: 'Explanation under a refundable rate plan policy in the flash cancellation options picker, with the number of days before check-in',
  },
  standardTitle: {
    id: 'h4lybNe-nb2pBD49MtX7',
    defaultMessage: 'Standard cancellation policy',
    description: 'Title of the rate plan policy in the flash cancellation options picker when its refund window cannot be summarised',
  },
})

export interface FlashCancellationOptionCopy {
  title: string
  /** Policy explanation for options that have no timeline modal of their own. */
  description?: string
}

export default function useFlashCancellationOptionCopy(): (policyType: App.CancellationPolicyType | undefined) => FlashCancellationOptionCopy {
  const intl = useIntl()

  return useCallback((policyType) => {
    const days = policyType ? CANCELLATION_POLICY_DAYS[policyType] : undefined

    if (policyType === CANCELLATION_POLICIES.NON_REFUNDABLE) {
      return {
        title: intl.formatMessage(messages.nonRefundableTitle),
        description: intl.formatMessage(messages.nonRefundableDescription),
      }
    }
    if (policyType === CANCELLATION_POLICIES.FLEXIBLE_CANCELLATION_TEN_DAYS) {
      return { title: intl.formatMessage(messages.flexibleCancellationTitle) }
    }
    if (policyType === CANCELLATION_POLICIES.CASH_REFUND_PRIOR_TO_CHECK_IN_TEN_DAYS) {
      return { title: intl.formatMessage(messages.fullyRefundableTitle) }
    }
    if (days) {
      return {
        title: intl.formatMessage(messages.flexibleCancellationTitle),
        description: intl.formatMessage(messages.otherRefundableDescription, { days }),
      }
    }
    return { title: intl.formatMessage(messages.standardTitle) }
  }, [intl])
}
